const MetodosEnvio = () => {
  return (
    <div>
      <p>
        <strong>ARGENTINA</strong>: Nuestros paquetes son enviados por Correo
        Argentino. La demora se encuentra entre 3 y 7 días hábiles luego de
        acreditado el pago. El costo del envio podes calcularlo con tu codigo
        postal en cada producto. También será mostrado en el checkout en base al
        total de la compra y ubicación. - <strong>SHOWROOM</strong>: podes
        retirarlo en nuestros showrooms sin costo. Belgrano: de lunes a viernes
        de 17 a 20hs. Siempre esperando confirmacion de cita previa. -{" "}
        <strong>MOTOS</strong> :Las compras pueden ser retiradas por cadetes
        contratados por el comprador. O con nuestra mensajeria. Todos los costos
        son a cargo del comprador. Los envios al <strong>EXTERIOR</strong> se
        realizan mediante la empresa Fedex, y el cargo de el mismo es a
        convenir.
      </p>
    </div>
  );
};

export default MetodosEnvio;
